import {Option} from '@/models';

export default [
	{
		path: '/option',
		name: 'option',
		meta: {
			title: 'Liste des option ',
			granted: [ 'API_GET_OPTION' ]
		},
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Option.vue')
	},
];